<template>
    <Wrapper>
        <Topbar button="goBack" logo="tipbox" step="1/3" />
        <h2 class="text-center mb-3">{{ $t('header') }}</h2>
        <p class="text-center mb-4">{{ $t('description') }}</p>
        <FormTipboxSettings @next="$router.push({ name: 'EntryPageTipBoxAddWebsite' })" />
        <div class="width-max-700 mx-auto p-3 bg-light rounded d-flex gap-2">
            <feather type="lock" size="16" class="flex-shrink-0 mt-1" />
            <p class="m-0">{{ $t('note') }}</p>
        </div>
    </Wrapper>
</template>


<script>
    import Wrapper from '../../parts/Wrapper.vue';
    import Topbar from '../../parts/Topbar.vue';
    import FormTipboxSettings from '../../parts/FormTipboxSettings.vue';

    export default {
        name: 'CompleteData',
        components: {
            Wrapper,
            Topbar,
            FormTipboxSettings,
        },
    };
</script>



<i18n lang="json" locale="pl" scope="local">
{
    "header": "Uzupełnij swoje dane",
    "description": "Zanim uruchomimy Twojego tip.BOX-a, potrzebujemy kilku informacji. To krótka formalność — wymagają tego od nas przepisy podatkowe i przepisy o przeciwdziałaniu praniu pieniędzy. Dzięki nim możemy bezpiecznie i legalnie przekazywać Ci środki od Twoich odbiorców.",
    "note": "Twoje dane są bezpieczne. Przechowujemy je zgodnie z przepisami RODO i przetwarzamy tylko w zakresie niezbędnym do świadczenia usługi."
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "header": "Complete your details",
    "description": "Before we launch your tip.BOX, we need a few pieces of information. It’s a brief formality required by tax and anti–money laundering regulations. This ensures we can securely and legally transfer funds from your supporters to you.",
    "note": "Your data is secure. We store it in accordance with GDPR and process it only as necessary to provide the service."
}
</i18n>
